// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner_spinner__CXksh","sk-bouncedelay":"Spinner_sk-bouncedelay__8Jn9O","bounce1":"Spinner_bounce1__i2TS3","bounce2":"Spinner_bounce2__50bpB"};